<template>
  <a-form layout="vertical" ref="formRef" :model="formState">
    <a-form-item name="content" label="Visualiza y edita el texto HTML" required>
      <a-textarea
        v-model:value="formState.content"
        :autosize="{ minRows: 8 }"
        placeholder="Escribir HTML"
      />
    </a-form-item>
  </a-form>
</template>

<script setup lang="ts">
import { reactive, ref } from "vue";
import { FormInstance } from "ant-design-vue";

import { HtmlItem } from "@/@types/flows/emailTemplates/items";

const props = defineProps<{ item: HtmlItem }>();

const formRef = ref<FormInstance>();
const formState: Partial<HtmlItem> = reactive({
  content: props.item.content,
});

const getValidatedFormState = async () => {
  await formRef.value?.validateFields();

  return formState;
};

defineExpose({ getValidatedFormState });
</script>

<style scoped lang="sass"></style>
